import { indexByUserId } from "blackswan-api";
import { ActiveConstants, ModelHelper } from "finhelper";
import { Api } from "laravel-request";

interface Account {
    account_number: string;
    groups: Group[];
}

interface Group {
    type_id?: string;
    items: any[];

    [key: string]: any;
}

type AccountsIndex = string[];
type AccountsGroupIndex = string[][];
type DateRange = {
    start: string;
    end: string;
};

/**
 *
 * @param id
 * @param domain
 * @param stateCallback
 */
export const getSinglePortfolio = (
    id: string | number,
    domain: string | undefined,
    stateCallback: any
) =>
    indexByUserId(
        id,
        ({ data }: { data: any }): void => succesCallbackOnSinglePortfolio(data, stateCallback),
        domain
    );

/**
 * Получить список оценок портфелей по датам
 * @param id идентификатор текущего юзера, залогиненного в CRM (не пользователя, по которому ищем, поиск идет по всем юзерам сразу)
 * @param userId один ID или массив ID пользователей
 * @param dates
 * @param accountNumber аккаунт атона, по которому нужна информация
 */
export const getAverageValuation = (
    id: string | number,
    userId: string | number | (string | number)[] | null | undefined,
    dates?: DateRange,
    accountNumber?: null | number | string
): any => {
    const whiteswanUrl = process.env.REACT_APP_API_WHITESWAN_URL;

    const params = new URLSearchParams();
    params.append("data[manager_id]", String(id));

    if (userId != null) {
        if (Array.isArray(userId)) {
            userId.forEach((uid) => params.append("data[user_id][]", String(uid)));
        } else {
            params.append("data[user_id]", String(userId));
        }
    }

    if (accountNumber != null) {
        params.append("data[account_number]", String(accountNumber));
    }

    if (dates?.start && dates?.end) {
        params.append("data[start]", dates.start);
        params.append("data[end]", dates.end);
    }

    const baseUrl = `sum-valuation?${params.toString()}`;

    return whiteswanUrl && Api.get("aton-portfolio", baseUrl).setDomain(whiteswanUrl);
};

/**
 *
 * @param data
 * @param stateCallback
 */
const succesCallbackOnSinglePortfolio = (data: any, stateCallback: any) => {
    const accounts: Account[] = [];
    const accuntsIndex: AccountsIndex = [];
    const accuntsGroupIndex: AccountsGroupIndex = [];

    data.forEach((row: { account_number: string; type_id: string }) => {
        let accountIndex = accuntsIndex.indexOf(row.account_number);
        if (accountIndex === -1) accuntsIndex.push(row.account_number);
        accountIndex = accuntsIndex.indexOf(row.account_number);

        if (typeof accounts[accountIndex] === "undefined") {
            accounts[accountIndex] = {
                account_number: row.account_number,
                groups: [],
            };
            accuntsGroupIndex[accountIndex] = [];
        }

        const groupString = `${row.account_number}-${row.type_id}`;
        let groupIndex = accuntsGroupIndex[accountIndex].indexOf(groupString);
        if (groupIndex === -1) {
            accuntsGroupIndex[accountIndex].push(groupString);
        }
        groupIndex = accuntsGroupIndex[accountIndex].indexOf(groupString);

        if (typeof accounts[accountIndex].groups[groupIndex] === "undefined") {
            const typeObject = ActiveConstants.getTypeById(row.type_id);
            accounts[accountIndex].groups[groupIndex] = typeObject ?? {};
            accounts[accountIndex].groups[groupIndex].items = [];
        }
        accounts[accountIndex].groups[groupIndex].items.push(row);
    });

    stateCallback(accounts);
};

export const getSingleUserAccount = (
    userId: any,
    callbackOnSuccess: (arg0: { data: any; result: string; meta?: any }) => any,
    callbackOnFailure: (arg0: XMLHttpRequest) => any
) => {
    Api.get("user-account", "index", { user_id: userId })
        .where("is_visible", 1)
        .with("accounts", "accounts.currency")
        .orderBy("type_id")
        .all(
            (successfulResponse) => {
                ModelHelper.accounts = successfulResponse.data;
                callbackOnSuccess && callbackOnSuccess(successfulResponse);
            },
            (failedResponse) => {
                callbackOnFailure && callbackOnFailure(failedResponse);
            }
        );
};
